import {IFilePickerFile} from "../components/FilePickerButton/FilePickerButton.interfaces";

export enum ButtonActionType {
    Link, Script
}

export interface IButtonMessage {
    id?: string;
    title?: string;
    link?: string;
    translationId?: string;
    actionType?: ButtonActionType;
    script?: IFilePickerFile;
}